<template>
  <b-container>
    <div class="title" v-if="!submitted">
      <h1>{{ checklist.formName }}</h1>
    </div>
    <checklist-fill
      v-if="!submitted"
      class="container-publico"
      ref="teste"
      :token="token"
      :checklist="checklist"
      :lg="'12'"
      :md="'12'"
      :sm="'12'"
      :isSharedFill="true"
      @finishFilling="finalizeFill"
      @fillingCheclistId="saveFillingId"
    >
    </checklist-fill>
    <div class="container-info">
      <span :class="message.type" v-if="message">{{ message.text }}</span>

      <div class="text" v-if="message && submitted">
        No APP RMS você consegue criar qualquer tipo de checklist, caso tenha
        dúvidas converse com a nossa equipe.

        <div style="margin-top: 20px;">
          Visite nosso site:
          <a href="https://rmschecklist.com.br" target="_blank"
            >https://rmschecklist.com.br</a
          >
        </div>
      </div>
      <div class="button-container" style="margin-top: 20px;">
        <b-button
          v-if="filledDetails.id"
          class="button-width"
          @click="exportPdf"
        >
          Exportar PDF
          <img
            style="margin-left:10px"
            height="25"
            src="/img/pdf-icon.png"
            alt="pdf"
          />
        </b-button>
      </div>
      <div class="button-container">
        <b-button
          v-if="
            sharedFill != null &&
              sharedFill.sharedFillType === 1 &&
              submitted &&
              sharedFill.active
          "
          class="button-width"
          @click="reloadSharedFill"
          >Novo Preenchimento</b-button
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import ChecklistFill from "@/mixins/checklist/fill/ChecklistFill";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import { openDB } from "idb";

Vue.use(VueScrollTo);

export default {
  name: "SharedFill",
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue")
  },
  mixins: [ChecklistFill],
  props: {
    SharedFillGuid: String
  },
  data() {
    return {
      checklist: {
        id: 0,
        formId: 0,
        formName: "",
        draft: false,
        values: [
          {
            fieldId: 0,
            fieldName: "",
            fieldTip: "",
            fieldType: 6,
            allowsAttachment: false,
            required: false,
            value: "",
            options: null
          }
        ]
      },
      sharedFill: {
        sharedFillType: 0,
        sharedFillToken: "",
        formId: 0,
        active: true
      },
      token: "",
      message: {
        type: "",
        text: ""
      },
      submitted: false,
      parameters: {
        optionMode: 0,
        optionSize: 1
      },
      filledDetails: {
        id: 0
      }
    };
  },
  mounted() {
    this.getChecklistIdByGuid(this.SharedFillGuid);
  },
  methods: {
    reloadSharedFill() {
      window.location.reload();
    },
    async finalizeFill() {
      try {
        if (this.sharedFill.sharedFillType == 0) {
          await this.inactivateSharedFillByGuid(this.SharedFillGuid);
        }
        this.message = {
          type: "success",
          text: "Obrigado por preencher o formulário!"
        };
        this.submitted = true;
      } catch (error) {
        console.error("Error loading data:", error);
      }
    },
    getTokenByGuid(guid) {
      return this.$apiChecklist.get("/checklist/getsharedfill/" + guid);
    },
    async getChecklistIdByGuid(guid) {
      try {
        this.submitted = false;
        this.filledDetails.id = 0;
        this.message = {
          type: "",
          text: ""
        };
        const response = await this.$apiChecklist.get(
          "/checklist/getsharedfill/" + guid
        );
        this.sharedFill = response.data.data.data;
        if (this.sharedFill == null) {
          this.submitted = true;
          this.message = {
            type: "warning",
            text: "Este link não é válido!"
          };
          return;
        }

        this.$store.state.token = this.sharedFill.sharedFillToken;
        this.token = this.sharedFill.sharedFillToken;

        if (this.sharedFill.active) {
          const checklist = await this.fetchChecklistFromIndexedDb(
            this.sharedFill.formId
          );
          if (checklist) {
            this.checklist = checklist;
            return;
          }
          this.checklist = await this.getChecklistNew(
            this.token,
            this.sharedFill.formId
          );
          console.log("Checklist from API:", this.checklist);
        } else {
          this.submitted = true;
          this.message = {
            type: "warning",
            text:
              "Este link já foi utilizado, ou está vencido! Se necessário entre em contato com o responsável."
          };
        }
      } catch (error) {
        this.submitted = false;
        console.error("Error fetching checklist ID by GUID:", error);
      }
    },
    async inactivateSharedFillByGuid(SharedFillGuid) {
      try {
        this.submitted = true;
        const config = {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        };
        const response = await this.$apiChecklist.post(
          "/form/InactivateSharedFill/" + SharedFillGuid,
          {},
          config
        );
      } catch (error) {
        console.error("Error inactivating shared fill:", error);
      }
    },
    saveFillingId(id) {
      this.filledDetails.id = id;
    },
    exportPdf() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.token}`
        },
        responseType: "arraybuffer"
      };

      this.$apiChecklist
        .get(
          `/v2/checklist/exporttopdf/${this.filledDetails.id}/${this.parameters.optionMode}/${this.parameters.optionSize}`,
          config
        )
        .then(response => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"]
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(error => {
          console.error("Error exporting PDF:", error);
        });
    },
    async fetchChecklistFromIndexedDb(formId) {
      if (!("indexedDB" in window)) {
        console.error("Este navegador não suporta IndexedDB");
        return;
      }

      const dbName = "checklistDB";
      const storeName = "drafts";
      const version = 1;

      try {
        const db = await openDB(dbName, version, {
          upgrade(db) {
            if (!db.objectStoreNames.contains(storeName)) {
              db.createObjectStore(storeName, { keyPath: "formId" });
            }
          }
        });

        const tx = db.transaction(storeName, "readonly");
        const store = tx.objectStore(storeName);
        const checklist = await store.get(formId);

        if (checklist) {
          console.log("Checklist recuperado com o ID:", formId, checklist);
          return checklist;
        } else {
          console.log("Nenhum checklist encontrado com o ID:", formId);
          return null;
        }
      } catch (error) {
        console.error("Erro ao recuperar do IndexedDB", error);
        return null;
      }
    }
  }
};
</script>
<style scoped>
/* (min-width: 1200px) */
.container-publico {
  @media (min-width: 768px) {
    width: 510px;
  }
}
.warning {
  color: red;
  font-size: 1.5em;
  margin-top: 1%;
  margin-left: 1%;
}
.success {
  color: #9cff19;
  font-size: 1.5em;
  margin-top: 1%;
  margin-left: 1%;
}
.text {
  color: white;
  margin-top: 1%;
  margin-left: 1%;
  font-size: 1.2em;
}
a {
  text-decoration: underline;
}
.button-container {
  display: flex;
  justify-content: center; /* Centraliza o botão na div */
  width: 250px; /* Ajuste conforme necessário */
}
.button-width {
  flex: 1; /* Faz com que os botões expandam para preencher o container */
}
.title {
  display: flex;
  justify-content: center;
  margin-top: 1%;
}
.container-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
